import React, { useState } from "react";
import styled from "styled-components";
import "swiper/components/pagination/pagination.min.css";
// import Swiper core and required modules
import SwiperCore, { Autoplay, Pagination } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/swiper.min.css";
import data from "../data/rushdata.json";

// install Swiper modules
SwiperCore.use([Pagination, Autoplay]);

const WhyDriver = () => {
  const [hover, sethover] = useState(2);
  return (
    <Wrapper>
      <div className="section-center text-center driver_rush">
        <div className="driver__rush_top">
          <h1>Why Drive with WecanRush?</h1>
          <p>
            Partner with us to drive your own livelihood and more. Let's get
            started on this journey together
          </p>
        </div>
        <div className="driver__rush_bottom">
          <div className="driver_rush_for_mobile">
            <Swiper
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              className="mySwiper"
            >
              {data.driverRushData.map(({ id, icon, rushH1, rushP }) => (
                <SwiperSlide key={id}>
                  <div className="single__rush">
                    <div className="rush__icon">
                      <img src={icon} alt="" />
                    </div>
                    <div className="rush__des">
                      <h1 className="rushH1">{rushH1}</h1>
                      <p className="rushp">{rushP}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="driver_rush_for_desktop">
            {data.driverRushData.map(({ id, icon, rushH1, rushP }) => (
              <div
                className={
                  hover === id ? "single__rush active" : "single__rush"
                }
                onMouseOver={() => sethover(id)}
                key={id}
              >
                <div className="rush__icon">
                  <img src={icon} alt="" />
                </div>
                <div className="rush__des">
                  <h1 className="rushH1">{rushH1}</h1>
                  <p className="rushp">{rushP}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  @media screen and (max-width: 768px) {
    .driver_rush {
      padding: 0px 12px !important;
      width: 100%;
    }
    .driver__rush_top {
      padding-top: 76px;
      h1 {
        font-size: 28px !important;
        width: 100% !important;
      }
      p {
        font-size: 14px !important ;
        line-height: 19px !important;
        text-align: center !important;
        width: 363px !important;
      }
    }
    .single__rush {
      width: 440px !important;
      margin: 0 20px;
    }

    .driver_rush_for_desktop {
      display: none !important;
    }
    .driver_rush_for_mobile {
      display: block !important;
      width: 100%;
    }
    .mySwiper {
      width: 516px;
      padding: 78px 0;
    }
    .rush__des p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: #464861;
      -webkit-letter-spacing: 1px;
      -moz-letter-spacing: 1px;
      -ms-letter-spacing: 1px;
      letter-spacing: 1px;
      margin-top: 10px;
      width: 300px;
    }
    .rush__des p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: #464861;
      -webkit-letter-spacing: 1px;
      -moz-letter-spacing: 1px;
      -ms-letter-spacing: 1px;
      letter-spacing: 1px;
      margin-top: 10px;
      width: 300px;
    }
  }

  @media screen and (max-width: 440px) {
    .mySwiper {
      width: 387px !important;
      padding: 78px 0;
    }
    .single__rush {
      width: 387px !important;
      border-radius: 15px !important;
      box-sizing: border-box !important;
      padding: 15px !important;
      margin-left: 8px !important;
      text-align: left;
      width: 366px !important;
      height: 329px;
      box-shadow: 0px 0px 50px 0px #e7f5ff !important;
    }

    .rush__des p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: #464861;
      -webkit-letter-spacing: 1px;
      -moz-letter-spacing: 1px;
      -ms-letter-spacing: 1px;
      -webkit-letter-spacing: 1px;
      -moz-letter-spacing: 1px;
      -ms-letter-spacing: 1px;
      letter-spacing: 1px;
      margin-top: 10px;
      width: 340px;
    }

    .rush__icon {
      margin-top: 40px;
    }

    .swiper-container-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
      max-width: 387px !important;
      display: flex;
      justify-content: center;
    }
    .driver__rush_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      margin-top: 110px;
      margin-bottom: 138px;
    }
  }

  .driver_rush_for_mobile {
    display: none;
  }
  .driver_rush_for_desktop {
    display: flex;
    flex-direction: row;
    align-items: space-between;
    width: 100%;
    margin: auto;
  }

  .driver__rush_bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    margin-top: 110px;
    margin-bottom: 180px;
  }

  .rush__icon {
    padding-left: 5px;
  }

  .driver__rush_top {
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 48px;
      line-height: 56px;
      text-align: center;
      color: #6300ff;
      width: 634px;
      height: 61px;
      margin: auto;
    }

    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 27px;
      text-align: center;
      color: #6d7d93;
      width: 950px;
      margin: auto;
      height: 54px;
      letter-spacing: 1px;
      margin-top: 40px;
    }
  }

  .rush__des {
    margin-top: 40px;
    h1 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 26px;
      line-height: 29px;
      color: #2a60e4;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: #464861;
      letter-spacing: 1px;
      margin-top: 10px;
    }
  }

  .single__rush {
    width: 340px;
    border-radius: 15px !important;
    /* box-shadow: 0px 0px 50px 0px #e7f5ff !important; */
    box-sizing: border-box !important;
    padding: 15px !important;
    margin-right: 50px;
    text-align: left;
    padding-top: 50px !important;
    padding-bottom: 50px !important;
    cursor: pointer;
    transition: 0.3s;
  }
  .single__rush.active {
    width: 340px;
    border-radius: 15px !important;
    box-shadow: 0px 0px 50px 0px #e7f5ff !important;
    box-sizing: border-box !important;
    padding: 15px !important;
    margin-right: 50px;
    text-align: left;
    padding-top: 50px !important;
    padding-bottom: 50px !important;
    cursor: pointer;
    transition: 0.3s;
  }
  .single__rush:hover {
    transform: scale(1.1);
  }

  .swiper-container.swiper-container-initialized.swiper-container-horizontal.swiper-container-pointer-events.mySwiper {
    padding-bottom: 90px;
  }
  .swiper-container-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    width: 500px !important;
  }
  .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 4px;
    width: 10px;
    height: 5px;
    border-radius: 5px;
  }

  .driver_rush {
    margin-top: 100px;
  }
`;

export default WhyDriver;
